import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import VanillaWrapper from "../VanillaWrapper/VanillaWrapper";

export default function Epedidos() {
  const { accessToken } = useAuth();
  const [token, setToken] = useState(accessToken || "");

  useEffect(() => {
    if (accessToken) {
      setToken(accessToken);
    }
  }, [accessToken]);

  return (
    <VanillaWrapper token={token} />
  );
}